import { SPRYKER_PRODUCTS_ALL_PATH } from '../constants';
import { ProductsApi } from '../types/api/products-api';
import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';
import { UrlBuilder } from './urlBuilder.service';
import { ProductsAllRequestParams } from '../types/api-params/productsAll';

export class SprykerProductsAllHandler extends RequestHandler {
  api = {
    target: 'spryker-products-all',
    default: 'spryker-default',
  };

  getProductsAll({
    countryCode,
    languageCode,
    productId,
    brand,
    idmsToken,
  }: ProductsAllRequestParams): NetworkResponse<ProductsApi.GetProductsAllResponse> {
    const headers: HeadersInit = {};

    if (idmsToken) {
      headers['User-Authorization'] = idmsToken;
    }

    return this.get<ProductsApi.GetProductsAllResponse>(
      UrlBuilder.buildSprykerURL({
        countryCode,
        languageCode,
        brand,
        endPointName: SPRYKER_PRODUCTS_ALL_PATH.replace('#product_id#', productId),
      }),
      {
        standardSettings: {
          headers,
        },
      },
    );
  }
}

export const SprykerProductsAll = new SprykerProductsAllHandler();
